import { FC, ReactNode } from "react";
import "./styles.scss";
import { Header } from "../Header";
import { useLandingLanguage } from "../../../hooks/useLandingLanguage";
import { isPublicNext } from "../../../next/public/mode";
import { SiteFrame } from "../../../next/public/SiteFrame";
import { LegacyWayBack } from "../../../next/public/LegacyWayBack";

interface IProps {
  children: ReactNode;
}

// Shared #eaf1fb background + Header wrapper used by every landing content
// page (/vision, /partnership, /platform, /team, /testimonials, /donate,
// /contact-us). The hero page at `/` keeps its own bespoke markup in
// Layout/index.tsx but renders the same shared Header.
export const PageShell: FC<IProps> = ({ children }) => {
  const { locale, handleLanguageChange } = useLandingLanguage();
  // The public switchboard line (next/public/mode.ts): the new frame carries the same pages.
  if (isPublicNext()) return <SiteFrame>{children}</SiteFrame>;

  return (
    <div className="landing-page-shell">
      <Header locale={locale} onLanguageChange={handleLanguageChange} />
      <main className="landing-page-shell__main">{children}</main>
      <LegacyWayBack />
    </div>
  );
};
